import logo2010 from "../../assets/img/historicEvents/LogoOverTheLimit/2010.png";
import logo2011 from "../../assets/img/historicEvents/LogoOverTheLimit/2011.png";
import logo2012 from "../../assets/img/historicEvents/LogoOverTheLimit/2012.png";

export const overTheLimitDetail = {
  "over-the-limit": {
    id: "over-the-limit",
    title: "Over the Limit",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "over-the-limit",
        items: [
          {
            id: "over-the-limit-2010",
            title: "Over The Limit",
            description: "2010",
            imgUrl: logo2010,
          },
          {
            id: "over-the-limit-2011",
            title: "Over The Limit",
            description: "2011",
            imgUrl: logo2011,
          },
          {
            id: "over-the-limit-2012",
            title: "Over The Limit",
            description: "2012",
            imgUrl: logo2012,
          },
        ],
      },
    ],
  },
};
